import { render, staticRenderFns } from "./v-tab-pane.vue?vue&type=template&id=a4a12a92"
import script from "./v-tab-pane.vue?vue&type=script&lang=js"
export * from "./v-tab-pane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4a12a92')) {
      api.createRecord('a4a12a92', component.options)
    } else {
      api.reload('a4a12a92', component.options)
    }
    module.hot.accept("./v-tab-pane.vue?vue&type=template&id=a4a12a92", function () {
      api.rerender('a4a12a92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/components/tabs/v-tab-pane.vue"
export default component.exports